'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as Bootstrap from 'bootstrap';
import dummy from './plugins';

import GoogleMapsLoader from 'google-maps';


import DialogRegion from '../../lib/views/dialogRegion/dialogRegion';
import language from '../../common/language';
import * as Entities_Module from '../../common/entities/module';

import config from '../../common/config';


import * as Entities_PublicCustomDepartment from '../entities/publicCustomDepartment';
import * as Entities_PublicCustomDepartmentReset from '../entities/publicCustomDepartmentReset';
import * as Entities_PublicCustomDepartmentUser from '../entities/publicCustomDepartmentUser';
import * as Entities_Font from '../../common/entities/font';
import * as Entities_PublicLuxaforboard from '../entities/publicLuxaforboard';
import * as Entities_Memory_Position from '../entities/memoryPosition';


import View_Region from '../views/region/region';

import helperSignalr from '../helper/helperSignalr';
var WebFont = require('webfontloader');

var app = module.exports = Marionette.Application.extend({
    onBeforeStart: function (options) {
        this.regions = new View_Region();
    },
    timedRefresh: function (timeoutPeriod) {
        setTimeout("location.reload(true);", timeoutPeriod);
    },
    wakeLock: function () {
        if ('wakeLock' in navigator) {
            window.infopage.WakeLockSupport = true;
        } else {
            alert(resources.X200352);
            window.infopage.WakeLockSupport = false;
        }



        if (window.infopage.WakeLock == 1) {
            if (window.infopage.WakeLockSupport) {
                try {
                    requestWakeLock();
                } catch (err) {
                    alert(err);
                }
            }
        }
    },
    wakeLockRetry: function () {
        //var luxaforboard_pomodoro_wakeLockReacquire = language.getCookie('luxaforboard_pomodoro_wakeLockReacquire');
        //if (luxaforboard_pomodoro_wakeLockReacquire == 1) {
        requestWakeLock();
        //}
    },
    onStart: function (options) {

        $(window).bind('resize', function () {
            location.reload(true);
        });

        window.infopage.SecretKey = this.getParameterByName('SecretKey');
        window.infopage.SecretCode = this.getParameterByName('SecretCode');
        window.infopage.Department = this.getParameterByName('Department');
        window.infopage.Auth = this.getParameterByName('Auth');
        window.infopage.Page = this.getParameterByName('Page');

        $.ajaxSetup({ cache: false });
        var self = this;

        language.getDefault();
        var luxaforboard_userCultureName = language.getCookie('luxaforboard_userCultureName');
        window.luxaforboard.config.cultureName = luxaforboard_userCultureName;

        var callback = function () {

            var languageCallback = function (resource) {
                window.resources = resource[0].attributes;

                var data = JSON.parse(self.entities.models.customDepartment.attributes.Data)[0];
                var moduleCollection = new Entities_Memory_Position.Collection(data.Collection);
                var moduleModel = moduleCollection.where({ ModuleType: self.entities.models.customDepartment.attributes.PersonOnView })[0];

                window.infopage.WakeLock = moduleModel.attributes.Data.WakeLock;

                self.wakeLock();

                helperSignalr.notification_init();
                helperSignalr.signalR_init();


                Backbone.history.start();

                if (window.infopage.Auth == '0') {
                    window.app.router.navigate("#noAuth");
                    window.app.router.noAuth();
                } else {
                    switch (window.infopage.Page) {
                        case 'infoPage': window.app.router.navigate("#infoPage"); window.app.router.infoPage(); break;
                        //self.timedRefresh(1 * 60000);
                    }
                }
            }

            language.setLanguageFromFile(window.luxaforboard.config.cultureName, window.luxaforboard.config.languageJson, languageCallback);
        }


        if (window.infopage.Auth == '0') {
            //callback();
            self.setupEntities(callback);
        } else {
            self.setupEntities(callback);
        }
    },
    setupEntities: function (callback) {
        var self = this;


        this.entities = {};
        this.entities.collections = {};
        this.entities.models = {};

        this.entities.models.customDepartment = new Entities_PublicCustomDepartment.Model();
        this.entities.collections.customDepartmentReset = new Entities_PublicCustomDepartmentReset.Collection();
        this.entities.collections.customDepartmentUser = new Entities_PublicCustomDepartmentUser.Collection();
        this.entities.collections.module = new Entities_Module.Collection();
        this.entities.collections.font = new Entities_Font.Collection();
        this.entities.collections.publicLuxaforboard = new Entities_PublicLuxaforboard.Collection();

        $.when(
            self.entities.collections.font.fetch({
                parseField: config.cultureName(),
                success: function (mode, response) {
                    self.entities.collections.Font = new Backbone.Collection(response.Font);
                },
                error: function (mode, response) {
                }
            }),
            self.entities.models.customDepartment.fetch({
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.entities.collections.customDepartmentUser.fetch({
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.entities.collections.customDepartmentReset.fetch({
                success: function (mode, response) {
                },
                error: function (mode, response) {
                }
            }),
            self.entities.collections.module.fetch({
                parseField: config.cultureName(),
                success: function (mode, response) {
                    window.module = response[config.cultureName()];
                    self.entities.collections.FontStyle = new Backbone.Collection(window.module.FontStyle);
                    self.entities.collections.TextAlign = new Backbone.Collection(window.module.TextAlign);
                    self.entities.collections.DigitalClockDateFormat = new Backbone.Collection(window.module.DigitalClockDateFormat);
                    self.entities.collections.DigitalClockHelper = new Backbone.Collection(window.module.DigitalClockHelper);
                },
                error: function (mode, response) {
                }
            }),
        ).done(function () {
            self.loadGoogleFont();
            window.luxaforboard.config.cultureName = self.entities.models.customDepartment.attributes.CultureName;
            callback();
        })
    },
    getLastestPush: function () {
        var self = this;
        var path = window.location.pathname;
        var page = path.split("/").pop();
        var eventId = page.substring(0, page.indexOf("_"));

        var eventPush = this.entities.collections.pushList.where({ EventId: window.luxaforboard.event.eventId });
        if (eventPush.length == 0) {
            var localLastDate = new Date(2015, 0, 1, 0, 0, 0, 1);
            this.entities.collections.pushList.create({ EventId: window.luxaforboard.event.eventId, LocalLastDate: localLastDate.getTime() });
        }

        eventPush = this.entities.collections.pushList.where({ EventId: window.luxaforboard.event.eventId });

        var tmpLocalDateTime = new Date(eventPush[0].attributes.LocalLastDate);

        var utcDateTime = tmpLocalDateTime.getUTCFullYear().toString() + '-' +
            (tmpLocalDateTime.getUTCMonth() + 1) + '-' +
            tmpLocalDateTime.getUTCDate().toString() + ' ' +
            tmpLocalDateTime.getUTCHours() + ':' + tmpLocalDateTime.getUTCMinutes() + ':' + tmpLocalDateTime.getUTCSeconds();

        var tmpModel = {};
        tmpModel.EventId = window.luxaforboard.event.eventId;
        tmpModel.UtcLastDate = utcDateTime;

        var callback = function () {
            self.entities.collections.publicCustomEventPush.forEach(function (entry) {
                window.app.signalR.notification.push(entry.attributes.Message);
                window.app.signalR.badgeCounter++;
                $('#badge').text(window.app.signalR.badgeCounter);
            });
        }

        this.entities.collections.publicCustomEventPush.fetch({
            readlist: false,
            tmpModel: tmpModel,
            success: function (mode, response) {
                //save last fetch
                var now = new Date();
                eventPush[0].attributes.LocalLastDate = now.getTime();
                eventPush[0].save();
                f
                callback();
            },
            error: function (mode, response) {
            }
        });
    },
    setupTriggers: function () {
        var self = this;

        this.listenTo(this, 'event4us', function (navigationName) {
            self.old_navigationName = navigationName;
            if (navigationName) {
                if (window.luxaforboard.event.refresh) {
                    window.luxaforboard.event.refresh = false;

                    this.router.navigate(navigationName);
                    window.location.reload();
                } else {
                    var tmpModel = self.entities.collections.headerWebpage.where({ navigationName: navigationName });
                    var decodeURI = window.decodeURI(navigationName);
                    var escape_decodeURI = escape(decodeURI);
                    var tmpModel_decodeURIComponent_escape = {};
                    try {
                        var decodeURIComponent_escape = window.decodeURIComponent(escape_decodeURI);
                        tmpModel_decodeURIComponent_escape = self.entities.collections.headerWebpage.where({ navigationName: decodeURIComponent_escape });
                    }
                    catch (err) {
                        tmpModel_decodeURIComponent_escape.length = 0;
                    }

                    self.entities.collections.headerWebpage.where({ navigationName: navigationName });

                    if ((tmpModel.length <= 0) && (tmpModel_decodeURIComponent_escape.length <= 0)) {
                        this.router.refreshDefaultPage();
                    } else {
                        var navigationTrigger = '';
                        var tmpNavigationName = navigationName;

                        if (tmpModel.length > 0) {
                            this.router.navigate(navigationName);
                            window.luxaforboard.event.lastNavigationName = navigationName;
                            navigationTrigger = tmpModel[0].attributes.navigationTrigger;
                            var tmpNavigationName = tmpModel[0].attributes.navigationName;
                        } else if (tmpModel_decodeURIComponent_escape.length > 0) {
                            this.router.navigate(tmpModel_decodeURIComponent_escape[0].attributes.navigationName);
                            window.luxaforboard.event.lastNavigationName = tmpModel_decodeURIComponent_escape[0].attributes.navigationName;
                            navigationTrigger = tmpModel_decodeURIComponent_escape[0].attributes.navigationTrigger;
                            var tmpNavigationName = tmpModel_decodeURIComponent_escape[0].attributes.navigationName;
                        }

                        if (window.luxaforboard.event.enableAdvertisingForApplication) {
                            $("#header-ad").empty();
                            //$("#header-ad").append('<center><script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script><!-- EVENT4US_LARG_MB --><ins class="adsbygoogle" style="display:inline-block;width:320px;height:100px" data-ad-client="ca-pub-8290043489538510" data-ad-slot="2206486830"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></center>');
                        }

                        switch (navigationTrigger) {
                            case 'schema':
                                this.router.schema(tmpNavigationName);
                                break;
                            case 'schemaBigscreen':
                                this.router.schemaBigscreen(tmpNavigationName);
                                break;
                            case 'info':
                                this.router.info(tmpNavigationName);
                                break;
                            case 'poster':
                                this.router.poster(tmpNavigationName);
                                break;
                        }
                    }
                }
            }
        });
    },
    initContent: function () {
        //var tmpModel = this.entities.collections.headerWebpage.where({ default: true });
        //this.trigger('event4us', tmpModel[0].attributes.navigationName);
    },
    getParameterByName: function (name) //courtesy Artem
    {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.href);
        if (results == null)
            return "";
        else
            return decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    getParameterByUrl: function (url) {
        var arr = url.split('/');
        return arr;
    },
    loadGoogleFont: function () {
        var fonts = [];

        this.entities.collections.Font.forEach(function (entry) {
            if (entry.attributes.data_font_style.length > 0)
                fonts.push(entry.attributes.data_font_family + ':' + entry.attributes.data_font_style);
            else
                fonts.push(entry.attributes.data_font_family);
        });

        WebFont.load({
            google: {
                families: fonts
            }
        });
    }
});



